import React from 'react'
import { sendGetEndpoint } from '../services/baseApi'
import { useDispatch } from 'react-redux'
import { BASE_OPT_IN_MODAL } from '../redux/types/base'
import { useSelector } from 'react-redux'

export const useOptInModal = (setFinishChanges) => {
  const dispatch = useDispatch()
  const [isOptInModalOpen, setIsOptInModalOpen] = React.useState(false)
  const { isIBVVerified, requestWidgetURL, pendingVerification } = useSelector(state => state.base.ibv) || {}
  const { optInModalInfo } = useSelector(state => state.base)
  const { appOrigin } = useSelector(state => state.user)


  const getOptInModal = React.useCallback(async () => {
    const res = await sendGetEndpoint('/optin-settings/')
    if (res && !res?.error){
      const cleanData = res.filter(item => typeof item === "object")
      dispatch({ type: BASE_OPT_IN_MODAL, payload: cleanData })
      // If there's a chirp IBV code to validate
      if (requestWidgetURL?.length && (!isIBVVerified)) {
        setFinishChanges(true)
        setIsOptInModalOpen(true)
      } 
    } 
  }, [
    dispatch, requestWidgetURL?.length,
    isIBVVerified, setFinishChanges
  ])

  // ! Logic used previously for displaying the OptIn
  React.useEffect(() => {
    setTimeout(() => {
      // getOptInModal()
    }, 1000)
  }, [isIBVVerified, getOptInModal])

  React.useEffect(() => {
    if ((pendingVerification)) {
      setFinishChanges(true)
      // setIsOptInModalOpen(true)
    } 
  }, [pendingVerification, requestWidgetURL?.length, setFinishChanges]) 
  // ! ----------------------------------------------


  // ? New logic for IBV in register (HomepageStarterEmail)
  React.useEffect(() => {
    if (!optInModalInfo) {
      getOptInModal()
    }
  }, [appOrigin])

  return {
    isOptInModalOpen,
    setIsOptInModalOpen
  }
}
